import MainLayout from "../../layouts/MainLayout";
import {
  IoBusinessOutline, IoEyeOutline, IoRocketOutline,
  IoHomeOutline, IoSearchOutline, IoSwapHorizontalOutline,
  IoPhonePortraitOutline, IoChatboxOutline,
  IoMailOutline, IoCallOutline,
} from "react-icons/io5";
import "./styles.css";

function AboutPage() {
  return (
    <MainLayout isTopBar screenTitle="عن عقاراتي">
      <div className="sp-wrap" dir="rtl">

        <div className="sp-hero">
          <div className="sp-hero__icon">
            <IoBusinessOutline size={32} />
          </div>
          <h1 className="sp-hero__title">منصة عقاراتي</h1>
          <p className="sp-hero__sub">منصتك العقارية الموثوقة في ليبيا</p>
        </div>

        {/* من نحن */}
        <div className="sp-section">
          <div className="sp-section__head">
            <div className="sp-section__badge"><IoBusinessOutline size={17} /></div>
            <h2 className="sp-section__title">من نحن</h2>
          </div>
          <p>
            <strong>عقاراتي</strong> هي منصة عقارية صُممت من قبل خبراء في المجال العقاري لتكون أداة عملية وسهلة تجمع بين احتياجات المكاتب العقارية والمستخدمين الأفراد.
          </p>
          <p>
            انطلقت فكرة عقاراتي من تجربة ميدانية حقيقية في السوق الليبي، حيث لاحظنا أن أغلب التطبيقات الحالية تفتقد إلى خصائص يحتاجها الوسيط والمستثمر والباحث عن العقار. لذلك صممنا منصة بسيطة ودقيقة تخدم الطرفين بشكل فعّال.
          </p>
        </div>

        {/* رؤيتنا */}
        <div className="sp-section">
          <div className="sp-section__head">
            <div className="sp-section__badge"><IoEyeOutline size={17} /></div>
            <h2 className="sp-section__title">رؤيتنا</h2>
          </div>
          <p>
            أن نصبح الخيار المفضل في ليبيا لكل من يبحث عن وسيلة موثوقة وسهلة لإدارة الإعلانات العقارية والتواصل بين البائع والمشتري والمستأجر، عبر تجربة مريحة وواضحة بعيداً عن التعقيد.
          </p>
        </div>

        {/* مهمتنا */}
        <div className="sp-section">
          <div className="sp-section__head">
            <div className="sp-section__badge"><IoRocketOutline size={17} /></div>
            <h2 className="sp-section__title">مهمتنا</h2>
          </div>
          <p>
            تقديم تجربة عقارية متكاملة تدمج بين الخبرة المحلية والتقنية الحديثة، بحيث نوفر للمكاتب العقارية وأصحاب العقارات وسيلة احترافية للإعلان، ونمنح المستخدمين تجربة تصفح وبحث دقيقة تساعدهم على اتخاذ قراراتهم بثقة.
          </p>
        </div>

        {/* كيف تعمل */}
        <div className="sp-section">
          <div className="sp-section__head">
            <div className="sp-section__badge"><IoPhonePortraitOutline size={17} /></div>
            <h2 className="sp-section__title">كيف تعمل المنصة؟</h2>
          </div>
          <div className="sp-feature-grid">
            <div className="sp-feature-card">
              <div className="sp-feature-card__icon">
                <IoHomeOutline size={24} />
              </div>
              <p className="sp-feature-card__title">لأصحاب العقارات والمكاتب</p>
              <p className="sp-feature-card__text">
                نشر إعلانات العقارات بسهولة مع الصور والموقع والسعر وإدارتها من لوحة تحكم واضحة.
              </p>
            </div>
            <div className="sp-feature-card">
              <div className="sp-feature-card__icon">
                <IoSearchOutline size={24} />
              </div>
              <p className="sp-feature-card__title">للباحثين عن العقار</p>
              <p className="sp-feature-card__text">
                تصفح العقارات والبحث حسب الموقع والسعر والنوع مع التواصل المباشر مع المعلن.
              </p>
            </div>
          </div>
        </div>

        {/* خدماتنا */}
        <div className="sp-section">
          <div className="sp-section__head">
            <div className="sp-section__badge"><IoBusinessOutline size={17} /></div>
            <h2 className="sp-section__title">خدماتنا</h2>
          </div>
          <div className="sp-services-grid">
            <div className="sp-service-item">
              <div className="sp-service-item__icon"><IoHomeOutline size={18} /></div>
              <p className="sp-service-item__text">بيع العقارات</p>
            </div>
            <div className="sp-service-item">
              <div className="sp-service-item__icon"><IoBusinessOutline size={18} /></div>
              <p className="sp-service-item__text">إيجار العقارات</p>
            </div>
            <div className="sp-service-item">
              <div className="sp-service-item__icon"><IoSwapHorizontalOutline size={18} /></div>
              <p className="sp-service-item__text">البدل بين العقارات</p>
            </div>
            <div className="sp-service-item">
              <div className="sp-service-item__icon"><IoPhonePortraitOutline size={18} /></div>
              <p className="sp-service-item__text">تطبيق ذكي</p>
            </div>
            <div className="sp-service-item">
              <div className="sp-service-item__icon"><IoChatboxOutline size={18} /></div>
              <p className="sp-service-item__text">دعم فني مباشر</p>
            </div>
          </div>
        </div>

        {/* تواصل معنا */}
        <div className="sp-section">
          <div className="sp-section__head">
            <div className="sp-section__badge"><IoMailOutline size={17} /></div>
            <h2 className="sp-section__title">تواصل معنا</h2>
          </div>
          <p>نحن دائماً جاهزون لسماع اقتراحاتكم وملاحظاتكم لتطوير المنصة وتحسين التجربة.</p>
          <div className="sp-contact-box">
            <div className="sp-contact-row">
              <IoMailOutline size={18} />
              contact@aqaraty.ly
            </div>
            <div className="sp-contact-row">
              <IoCallOutline size={18} />
              <span dir="ltr">+218 555 555 555</span>
            </div>
          </div>
        </div>

      </div>
    </MainLayout>
  );
}

export default AboutPage;
